import { Link } from 'react-router-dom'
import { formatTimeLabel } from '../../../utils/date'
import { CONSULTATION_TYPE_LABELS, useGemstoneOffer } from './useGemstoneOffer'

/** Gem outline, shared with the gemstone booking page. */
export function GemIcon({ className = 'w-4 h-4' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 3h12l4 6-10 13L2 9Z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M11 3 8 9l4 13 4-13-3-6M2 9h20" />
    </svg>
  )
}

/**
 * Entry point to Raju Maharaj's gemstone consultation — shown on his profile
 * and booking pages. Renders nothing while loading or when the consultation is
 * switched off, so the pages never show a dead link.
 */
export default function GemstoneConsultationPromo() {
  const { offer } = useGemstoneOffer()
  if (!offer?.is_enabled) return null

  const types = offer.consultation_types.map((t) => CONSULTATION_TYPE_LABELS[t] ?? t).join(' · ')

  return (
    <div className="info-card overflow-hidden">
      <div className="h-0.75 w-full bg-linear-to-r from-[#C8922A] via-[#E5A820] to-[#C8922A]" />
      <div className="p-6 sm:p-7 flex flex-col sm:flex-row sm:items-center justify-between gap-5">
        <div className="flex items-start gap-4 min-w-0">
          <span
            className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-[#1C140A]"
            style={{ background: 'linear-gradient(135deg, #D4AF37 0%, #F7D08F 100%)' }}
          >
            <GemIcon className="w-5 h-5" />
          </span>
          <div className="min-w-0">
            <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-secondary mb-1">Also available</p>
            <h4 className="text-lg font-cinzel text-[#1C140A] leading-tight">Gemstone Consultation</h4>
            <p className="text-xs text-[#8B7355] mt-1.5">
              Find the right gemstone for you. Any day, {formatTimeLabel(offer.start_time)}–{formatTimeLabel(offer.end_time)} · {offer.duration} min · {types}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4 shrink-0">
          <p className="font-cinzel font-bold text-2xl text-gradient-gold">₹{Number(offer.rate).toLocaleString('en-IN')}</p>
          <Link
            to="/book-maharaj-ji/gemstone"
            className="hero-btn-primary inline-flex items-center justify-center rounded-full px-6 py-3 text-[10px] font-bold uppercase tracking-[0.2em]"
          >
            Book now
          </Link>
        </div>
      </div>
    </div>
  )
}
